import { useEffect } from 'react';
import type { GossipItem } from '@/mocks/gossip';

interface Props {
  item: GossipItem | null;
  onClose: () => void;
}

export default function ArticleModal({ item, onClose }: Props) {
  useEffect(() => {
    if (!item) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [item, onClose]);

  if (!item) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center p-0 sm:items-center sm:p-6">
      <div
        className="absolute inset-0 bg-foreground-950/60 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      <div className="modal-in relative z-10 flex max-h-[92vh] w-full max-w-2xl flex-col overflow-hidden rounded-t-2xl bg-background-50 sm:rounded-2xl">
        <div className="relative">
          <img
            src={item.image}
            alt={item.title}
            className="h-44 w-full object-cover sm:h-56"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-foreground-950/50 text-lg text-white transition-colors hover:bg-foreground-950/70"
          >
            <i className="ri-close-line"></i>
          </button>
          <div className="absolute bottom-3 left-4 right-4">
            <div className="flex flex-wrap items-center gap-2 text-xs text-white/85">
              <span className="rounded-full bg-primary-500 px-2.5 py-0.5 font-semibold text-white">
                {item.category}
              </span>
              <span>{item.time}</span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {item.views}
              </span>
            </div>
            <h2 className="mt-2 text-lg font-bold leading-snug text-white md:text-xl">
              {item.title}
            </h2>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-4 py-5 md:px-6">
          {item.content.map((p, i) => (
            <p key={i} className="mb-4 text-[15px] leading-7 text-foreground-700">
              {p}
            </p>
          ))}

          <div className="mt-4 flex items-center gap-2">
            <span className="text-xs text-foreground-500">本文标签</span>
            <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              {item.tag}
            </span>
          </div>

          <div className="mt-6 rounded-xl bg-secondary-100/70 px-4 py-3 text-xs leading-relaxed text-foreground-600">
            <i className="ri-information-line mr-1"></i>
            说明：本文内容基于公开报道整理，仅供吃瓜讨论参考，倡导理性阅读、不信谣不传谣。欢迎到投稿区聊聊你的看法，边吃边看更放心。
          </div>
        </div>
      </div>
    </div>
  );
}